module.exports = __webpack_public_path__ + "static/media/add_btn_line.5db6fdb2.svg";